const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/sections/Finalize.tsx';
import React, { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';
import textMap from 'App/config/ukbb/eCheckin/translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import mobileImage from 'App/components/eCheckin/components/sections/images/online_checkin_illustration_handy-1.svg';
import desktopImage from 'App/components/eCheckin/components/sections/images/online_checkin_illustration_desktop-1.svg';

const imageCSS = css`
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    max-height: 200px;
    width: 100%;
`;

export const Finalize = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <img src={`${smallScreen ? mobileImage : desktopImage}`} className={imageCSS} />
            <h1>{title}</h1>
            <div dangerouslySetInnerHTML={{ __html: formatMessage(textMap.finalizeContent) }} />
        </ECheckinSection>
    );
});

Finalize.displayName = 'Finalize';

export default Finalize;
